import {HtmlAreaToolbarManager} from "../editors/html/HtmlAreaToolbarManager.js";

const lookupEntity = Icon.entity;

export class FIconElement extends HTMLElement {
	constructor() {
		super();
	}

	syncName() {
		this.innerHTML = lookupEntity(this.getAttribute("name"));
	}

	set name(value) {
		if (value) this.setAttribute('name', value);
		else this.removeAttribute('name');
	}

	get name() {
		return this.getAttribute('name');
	}

	attributeChangedCallback(name, oldValue, newValue) {
		switch (name) {
			case "name":
				this.syncName();
				break;
		}
	}

	connectedCallback() {
		this.syncName();
	}

	static get observedAttributes() {
		return ['name'];
	}
}

customElements.define("f-icon", FIconElement);